// extracted by mini-css-extract-plugin
export default {"container":"Detail_container__iHi8W","label":"Detail_label__pK32T","value":"Detail_value__7GJ8D"};